import ProductWiseItem from "components/DisplayBoard/ProductWiseItem";
import Spinner from "components/Spinner";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import authHeader from "services/auth-header";
import API from "services/axios";

const EMBROIDERY_PRODUCT_TYPE = {
  id: 7,
  companyId: 3,
  //   productTypeId: 5,
  productTypeId: 3,
  sortId: 6,
  productTypes: "Embroidery",
  showOnJobBoard: true,
};

export default function TempEmbroideryBoard() {
  const [searchParams, setSearchParams] = useSearchParams();

  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [locationsData, setLocationsData] = useState(null);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [refreshStatusList, setRefreshStatusList] = useState({
    [EMBROIDERY_PRODUCT_TYPE.productTypes]: false,
  });

  const getAllLocations = async () => {
    try {
      setLoading(true);
      const { data } = await API.get("/locations", { headers: authHeader() });
      setLocationsData(data);
      setLoading(false);
    } catch (err) {
      alert(err.message);
      setLoading(false);
    }
  };

  const refreshAll = () => {
    setRefreshStatusList((prev) => {
      const newList = {};
      Object.keys(prev).forEach((item) => {
        newList[item] = true;
      });
      return newList;
    });
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      getAllLocations();
    }, 50);

    return () => clearTimeout(timeout);
  }, []);

  useEffect(() => {
    const locationId = searchParams.get("location");

    if (locationId) {
      setSelectedLocation(parseInt(locationId));
    }
  }, [searchParams]);

  return (
    <div style={{ paddingLeft: 280, paddingTop: 20, height: "100vh" }}>
      {loading && <Spinner />}

      <div
        className="nav nav-tabs nav-bordered mb-3 bg-white shadow-sm py-2 d-flex justify-content-between flex-grow-1"
        style={{
          position: "fixed",
          top: 0,
          width: "100vw",
          left: 0,
          paddingLeft: 280,
          zIndex: 101,
        }}
      >
        <div>
          <button className="btn active bg-primary text-white">
            Temp Board
          </button>
        </div>

        <div className="d-flex align-items-center gap-4">
          <button onClick={refreshAll} className="btn btn-success">
            Refresh
          </button>

          <div className="d-flex align-items-center gap-2 text-end">
            <h4>Location:</h4>
            <select
              className="form-control form-control-sm"
              value={selectedLocation || ""}
              onChange={(e) => {
                const selectedValue = e.target.value;

                if (selectedValue === "") {
                  setSelectedLocation(null);
                  setSearchParams((prev) => {
                    const newParams = new URLSearchParams(prev);
                    newParams.delete("location");
                    return newParams.toString();
                  });
                  return;
                }

                const parsedLocation = parseInt(selectedValue);
                setSelectedLocation(parsedLocation);
                setSearchParams((prev) => {
                  const newParams = new URLSearchParams(prev);
                  newParams.set("location", parsedLocation);
                  return newParams.toString();
                });
              }}
            >
              <option value=""> All </option>
              {locationsData?.map((item) => (
                <option key={item?.id} value={item?.id}>
                  {item?.locationName}
                </option>
              ))}
            </select>
          </div>

          <div className="text-end me-3">
            <div className="d-flex justify-content-center align-items-center">
              <input
                type="search"
                placeholder="Search..."
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                className="form-control me-3"
              />
            </div>
          </div>
        </div>
      </div>

      <div
        className="row justify-content-start scrollbar-hidee mx-auto"
        style={{ height: "90vh", marginTop: 60, overflowY: "auto" }}
      >
        <ProductWiseItem
          filterBy={{
            productTypeId: EMBROIDERY_PRODUCT_TYPE.productTypeId,
            productTypes: EMBROIDERY_PRODUCT_TYPE.productTypes,
          }}
          tempBoard={true}
          selectedLocation={selectedLocation}
          filterText={searchText}
          productTypesData={[EMBROIDERY_PRODUCT_TYPE]}
          refreshStatusList={refreshStatusList}
          setRefreshStatusList={setRefreshStatusList}
        />
      </div>
    </div>
  );
}
